// Techo de subida para documentos de sucursal/matriz (POST /branch-documents/upload).
// Única fuente de verdad del lado del frontend -- debe coincidir con
// conem.upload.max-file-size-mb en application.properties del backend. Si se cambia uno,
// hay que cambiar el otro (y REACT_APP_MAX_UPLOAD_MB en los .env si se usa esa vía).
export const MAX_BRANCH_DOCUMENT_UPLOAD_MB = Number(process.env.REACT_APP_MAX_UPLOAD_MB) || 150;
